import { render, staticRenderFns } from "./SopQmsRequirementEdit.vue?vue&type=template&id=0704b58a&scoped=true&"
import script from "./SopQmsRequirementEdit.vue?vue&type=script&lang=ts&"
export * from "./SopQmsRequirementEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704b58a",
  null
  
)

export default component.exports